import React, { Component } from 'react';
import Utils from '../../utils.js'

class SubBU extends Component {

	constructor(props) {
		super(props);
		this.state = {
			singleProxyEnv: "",
			singleProxyEnvError: false
		};
	}

	isValidated() {

		if(this.state.singleProxyEnvError === true) {
			this.props.updateStore({isSubmit: true});
			return false;
		}
		return true;
	}

	async componentDidMount() {
		let subBU = this.props.getStore().subBU;
		if(null === subBU || subBU === "") {
			this.props.updateStore({
				subBU: "WSRS"
			});
		}else{
			subBU = this.props.getStore().subBU;
		}

		this.setState({ singleProxyEnvError: false });
		// on load setting it to WSRS in case of empty subBU
		let data = this.props.getStore();
		const proxyName = Utils.constructProxyComponentName(subBU, data.virtualPath);
		this.setState({ proxyName: proxyName });

		// If Utils.validateIfProxyAlreadyExists is async, you need to make it sync or handle it differently.
		// Here, assuming a synchronous check (or you can use .then to update state after promise resolves).
		await Utils.validateIfProxyAlreadyExists(this, proxyName);
	}
	componentDidUpdate() {


	}


	//lambda ensures correct 'this' scope
	onChange = async (e) => {
		this.setState({ singleProxyEnvError: false });
		this.props.updateStore({
			subBU: e.target.value
		});
		let data = this.props.getStore();
		const proxyName = Utils.constructProxyComponentName(e.target.value, data.virtualPath);
		this.setState({ proxyName: proxyName });

		// If Utils.validateIfProxyAlreadyExists is async, you need to make it sync or handle it differently.
		// Here, assuming a synchronous check (or you can use .then to update state after promise resolves).
		await Utils.validateIfProxyAlreadyExists(this, proxyName);

	}

	render() {
		return <div>
			<div className="container">
				<br/>
				<div className="row">
					<div className="col-md-8">
						<h4>Select Business Unit</h4>
						<p>Only really relevant for naming - if you are not sure WSRS (FSA) is likely the right answer.</p>
						<br/>
						{generateRadioHtml(["WSRS","ANNUITIES","PSI","BANK","DTC","PCS"],"subBU", this.props.getStore, this.onChange)}
					</div>
				</div>
			</div>
			 {this.state.singleProxyEnvError && (
                        <p className="alert alert-danger util-margin-top-10">
                            APIProxy named '{this.state.proxyName}' is already present in the environment ({this.state.singleProxyEnv}). Please select an appropriate option from the "Build Environment" & "Routing" step and try again.
                        </p>
            )}
		</div>
	}
}

const generateRadioHtml = (list, name, getStore, onChange) => {
	list = list.map((item) =>
		<div key={item} className="radio hzn-radio-card">
			<input type="radio" name={name} id={item} value={item} checked={getStore()[name]===item} onChange={onChange}/>
			<label htmlFor={item}>{item}</label>
		</div>
	);
	return <div className="hzn-radio-card-wrapper">
		{list}
	</div>
}


export default SubBU;